import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { WrappedImage } from '../WrappedImage';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';

interface WingoPerSessionCardProps {
  avgWingoPerSession: number | null;
  avatarUrl?: string;
  username?: string;
}

export const WingoPerSessionCard: React.FC<WingoPerSessionCardProps> = ({
  avgWingoPerSession,
  avatarUrl,
  username,
}) => {
  if (avgWingoPerSession === null) {
    return (
      <WrappedCard username={username}>
        <p className="text-lg text-yellow-300">No session data available</p>
      </WrappedCard>
    );
  }

  // Check which wrapped image to show
  const normalizedUsername = username?.toLowerCase().trim() || '';
  // Normalize spaces and underscores for matching
  const normalizedForMatch = normalizedUsername.replace(/[\s_]+/g, '');
  let imageSrc: string;
  let imageAlt: string;
  
  if (normalizedUsername.includes('trimbawolf')) {
    imageSrc = '/trimbawolf-wrapped-2.png';
    imageAlt = 'Trimbawolf Wrapped';
  } else if (
    normalizedUsername.includes('erock') ||
    normalizedUsername.includes('melathon') ||
    normalizedUsername.includes('kat') ||
    normalizedUsername.includes('coach_2') ||
    normalizedUsername.includes('coach 2') ||
    normalizedForMatch.includes('coach2')
  ) {
    imageSrc = '/wrapped-wingo.jpeg';
    imageAlt = 'Wrapped WINGO';
  } else {
    // Default image for all others
    imageSrc = '/wingatebw1.jpg';
    imageAlt = 'Wingate Track';
  }

  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        {/* Image - always show */}
        <div className="flex justify-center mb-3 md:mb-4">
          <div className="relative" style={{ width: 'fit-content', maxWidth: '100%' }}>
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse rounded-2xl"></div>
            <WrappedImage
              src={imageSrc}
              alt={imageAlt}
              fallbackSrc={imageSrc.includes('wrapped-wingo') ? '/wingatebw1.jpg' : undefined}
              className="relative rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ 
                maxHeight: '280px', 
                maxWidth: '100%',
                height: 'auto',
                width: 'auto',
                objectFit: 'contain',
                display: 'block'
              }}
              maxHeight="280px"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                if (!target.src.includes('wingatebw1')) {
                  target.style.display = 'none';
                }
              }}
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl">
          <p className="text-lg md:text-xl lg:text-2xl text-yellow-200 font-bold px-2 text-center">
            You mined {avgWingoPerSession.toFixed(1)} WINGO per session.
          </p>
        </div>
      </div>
    </WrappedCard>
  );
};

